import { Box,Center,Circle,Text, useMediaQuery, useColorMode } from '@chakra-ui/react'
import React from 'react'
import { Typewriter } from 'react-simple-typewriter'
import TypeWriter from './Typewriter'
const sample_content = `Alive = True;
while Alive:
  try:
   hard();
  except Exception as in life:
   jumpOverIt();
   tryagain();`;



function Terminal() {
const { colorMode, toggleColorMode } = useColorMode();
const isDark = colorMode === "dark";
var today = new Date();
var day = today.getDay()
var dd = today.getDate()
var mm = today.getMonth() + 1; //January is 0!
var yyyy = today.getFullYear();

let par  =`Personal Information:
-> Name: Hamza Al Sorkhy
-> DOB: July 16, 2002
-> Nationalit(y/ies): Canada
-> Education: Bacehlor of Applied Science in Computer Science, McMaster University (2020-2024)
-> email: alsorkhyy@gmail.com


Experience:
-> Porosheets.com - Founder and lead engineer (Sept 2023 - Present) 

-> Medsender - Software engineering intern (Jan 2024 - May 2024)

-> AtSign Company - Software developer intern (June 2022 - July 2022)

-> CodeDriven - Lead Front end developer (June 2021 - February 2023)

-> GlobalDWS - AI developer intern/ technical associate (Aug 2021 - Sept 2021)

-> Arabia Insurance Cooperative company - Freelance frontend developer (Aug 2021 - Sept 2021)

-> Muslim Society of Guelph - Full stack freelance developer (June 2022 - February 2023)



Skills and Languages:
-> Python
-> JavaScript
-> React
-> NextJS
-> Azure
-> Firebase
-> Planetscale
-> Supabase
-> MongoDB
-> SQL
-> Java
-> C/C++
-> Haskell
-> Elm
-> C#
-> .NET`
let words = par.split(' ')
console.log(words)
let week = {
  0: 'Sun',
  1: 'Mon',
  2: 'Tue',
  3: 'Wed',
  4: 'Thur',
  5: 'Fri',
  6: 'Sat',
}
let months = {
  1: 'Jan',
  2: 'Feb',
  3: 'Mar',
  4: 'Apr',
  5: 'May',
  6: 'Jun',
  7: 'Jul',
  8: 'Aug',
  9: 'Sep',
  10: 'Oct',
  11: 'Nov',
  12: 'Dec',
}
today = mm + '/' + dd + '/' + yyyy;
const [isNotSmall] = useMediaQuery("(min-width: 1100px)");
  
  const [isNotVerySmall] = useMediaQuery("(min-width: 600px)");
console.log(window.innerWidth)
  return (
    <Box
    minHeight={'70vh'}

    width={isNotSmall ? '840.5px' : '80vw' }
    bg={isDark ? 'rgb(21,25,31)' : 'black'}
    color={'white'}
    
    borderWidth='1px' borderRadius='lg'
    
    >
      <Box height={'30px'} borderTopRadius={'lg'} color={isDark ? 'white' : 'grey'} borderWidth='1px' bg={isDark ? 'rgb(58,51,54)' : 'white'} display={'flex'} >
        <Box flex={1} flexBasis={0} display={'flex'} flexDirection={'row'} gap={'5px'} margin={'5px'} alignItems={'center'}>
          <Circle size='12px' bg='tomato' color='white'></Circle>
          <Circle size='12px' bg='rgb(252,189,46)' color='white'></Circle>
          <Circle size='12px' bg='rgb(43,200,64)' color='white'></Circle> 
        </Box>
        <Text display={'flex'} alignItems={'center'} justifyContent={'center'}  flex={1} flexBasis={0} fontFamily={'monospace'} fontWeight={'bold'} m={'5px'}> alsorkhyy@gmail.com</Text>
         <Box flex={1} flexBasis={0} ></Box>
      </Box>
      <Text  fontFamily={'monospace'} fontWeight={'bold'} m={'5px'}> Last login: {week[day] + " " + months[mm] + " " + dd} on ttys001</Text>
      <Box paddingLeft={'10px'}
    paddingRight={'10px'}
    >
      <TypeWriter content={par} speed={20} />
    </Box>
        
        
          
    </Box>
  )
}

export default Terminal